<template>
    <b-card no-body>
        <v-table ref="table" name="fuel-credit-card" :items-provider="provider" :fields="fields" :buttons="buttons" pagination="server" search :add-callback="createNew"> </v-table>

        <b-modal v-model="modal.show" :title="modal.title" ok-title="Kaydet" ok-only @ok.prevent="save" :busy="modal.busy">
            <form ref="form">
                <div class="mb-1">
                    <label class="form-label">Banka Seçimi</label> <span class="text-danger">*</span>
                    <v-validator :errors="errors" parameter="BankId" :watch="form.BankId">
                        <v-select-list v-model="form.BankId" :options="bankList" label="BankName" :reduce="(x) => x.Id" placeholder="Banka seçiniz..." />
                    </v-validator>
                </div>

                <div class="mb-1">
                    <label class="form-label">Kart Son 4 Hane</label> <span class="text-danger">*</span>
                    <v-validator :errors="errors" parameter="CreditCardLast4Value" :watch="form.CreditCardLast4Value">
                        <b-form-input v-model="form.CreditCardLast4Value" placeholder="****" :formatter="(val) => formatNumber(val, 4)" />
                    </v-validator>
                </div>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Son Kullanma Ay</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="ExpireMonth" :watch="form.ExpireMonth">
                                <b-form-input v-model="form.ExpireMonth" placeholder="AA" :formatter="(val) => formatNumber(val, 2)" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Son Kullanma Yıl</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="ExpireYear" :watch="form.ExpireYear">
                                <b-form-input v-model="form.ExpireYear" placeholder="YYYY" :formatter="(val) => formatNumber(val, 4)" />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Hesap Kesim Günü</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="AccountClosingDay" :watch="form.AccountClosingDay">
                                <b-form-input v-model="form.AccountClosingDay" type="number" min="1" max="31" placeholder="1-31" :formatter="(val) => formatNumber(val, 2)" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Son Ödeme Günü</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="AccountLastPaymentDay" :watch="form.AccountLastPaymentDay">
                                <b-form-input v-model="form.AccountLastPaymentDay" type="number" min="1" max="31" placeholder="1-31" :formatter="(val) => formatNumber(val, 2)" />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>

                <div class="mb-1">
                    <b-form-checkbox v-model="form.IsActive" switch> Aktif </b-form-checkbox>
                </div>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BModal, BFormCheckbox, BFormInput, BRow, BCol } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import BankApi from "@/api/bank";
import VSelectList from "@/components/VSelectList.vue";
import VValidator from "@/components/VValidator";

export default {
    components: {
        BCard,
        BModal,
        BFormCheckbox,
        BFormInput,
        BRow,
        BCol,
        VSelectList,
        VValidator,
    },
    data() {
        return {
            fields: [
                { name: "Banka", key: "BankName", sortable: true, sortKey: "Bank.Name", tdClass: "w-24 text-nowrap" },
                { name: "Kart Son 4", key: "CreditCardLast4Value", sortable: true, sortKey: "CreditCardLast4Value", tdClass: "w-22 text-nowrap text-right" },
                { name: "Hesap Kesim", key: "AccountClosingDay", sortable: true, sortKey: "AccountClosingDay", tdClass: "w-22 text-nowrap text-right" },
                { name: "Son Ödeme", key: "AccountLastPaymentDay", sortable: true, sortKey: "AccountLastPaymentDay", tdClass: "w-22 text-nowrap text-right" },
                { name: "Durum", key: "IsActive", sortable: true, sortKey: "IsActive", tdClass: "w-10 text-nowrap text-right" },
            ],
            buttons: [
                {
                    text: "Düzenle",
                    icon: "EditIcon",
                    variant: "primary",
                    action: (item) => this.edit(item),
                },
                {
                    text: "Sil",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: (item) => this.remove(item),
                },
            ],
            modal: {
                show: false,
                title: "Yeni Kredi Kartı",
                busy: false,
                isEdit: false,
            },
            form: {
                Id: null,
                BankId: null,
                CreditCardLast4Value: "",
                ExpireMonth: null,
                ExpireYear: null,
                AccountClosingDay: null,
                AccountLastPaymentDay: null,
                IsActive: true,
            },
            errors: {},
            bankList: [],
        };
    },
    created() {
        this.getBanks();
    },
    methods: {
        provider(data) {
            return FuelStorageApi.FuelStorageCreditCardInformation.Table(data);
        },
        async getBanks() {
            try {
                const res = await BankApi.List();
                if (res.data.Success) {
                    this.bankList = res.data.Data;
                }
            } catch (error) {
                console.error("Banka listesi yüklenemedi", error);
            }
        },
        createNew() {
            this.resetForm();
            this.modal.isEdit = false;
            this.modal.title = "Yeni Kredi Kartı";
            this.modal.show = true;
        },
        edit(item) {
            this.form = { ...item };
            this.errors = {};
            this.modal.isEdit = true;
            this.modal.title = "Kredi Kartı Düzenle";
            this.modal.show = true;
        },
        save() {
            this.errors = {};
            if (!this.form.BankId) this.$set(this.errors, "BankId", "Banka seçimi zorunludur.");
            if (!this.form.CreditCardLast4Value) this.$set(this.errors, "CreditCardLast4Value", "Kart bilgisi zorunludur.");

            if (Object.keys(this.errors).length > 0) return;

            this.modal.busy = true;

            FuelStorageApi.FuelStorageCreditCardInformation.CreateOrUpdate(this.modal.isEdit, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.modal.show = false;
                        this.$toast.success(res.data.Message);
                    } else {
                        this.$toast.error(res.data.Message);
                    }
                })
                .catch((err) => {
                    this.$toast.error("İşlem sırasında hata oluştu.");
                })
                .finally(() => {
                    this.modal.busy = false;
                });
        },
        remove(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Seçili kart silinecektir.`).then((res) => {
                if (res) {
                    this.$refs.table.rowLoading(true);
                    FuelStorageApi.FuelStorageCreditCardInformation.Delete(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        })
                        .finally(() => {
                            this.$refs.table.rowLoading(false);
                        });
                }
            });
        },
        resetForm() {
            this.form = {
                Id: null,
                BankId: null,
                CreditCardLast4Value: "",
                ExpireMonth: null,
                ExpireYear: null,
                AccountClosingDay: null,
                AccountLastPaymentDay: null,
                IsActive: true,
            };
            this.errors = {};
        },
        formatNumber(value, maxLength) {
            if (!value) return value;
            return String(value).replace(/\D/g, "").slice(0, maxLength);
        },
    },
};
</script>
